"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaxReportSchema = exports.TaxByPeriodRowSchema = exports.TaxByLocationRowSchema = exports.TaxByTypeRowSchema = void 0;
const zod_1 = require("zod");
exports.TaxByTypeRowSchema = zod_1.z.object({
    taxType: zod_1.z.string(),
    taxName: zod_1.z.string().optional(),
    taxableRevenue: zod_1.z.number(),
    taxCollected: zod_1.z.number(),
    ratePct: zod_1.z.number().optional(),
});
exports.TaxByLocationRowSchema = zod_1.z.object({
    locationId: zod_1.z.string(),
    locationName: zod_1.z.string(),
    taxableRevenue: zod_1.z.number(),
    taxCollected: zod_1.z.number(),
});
exports.TaxByPeriodRowSchema = zod_1.z.object({
    date: zod_1.z.string(),
    taxableRevenue: zod_1.z.number(),
    taxCollected: zod_1.z.number(),
});
exports.TaxReportSchema = zod_1.z.object({
    tenantId: zod_1.z.string(),
    locationId: zod_1.z.string(),
    from: zod_1.z.string(),
    to: zod_1.z.string(),
    totalTaxCollected: zod_1.z.number(),
    taxableRevenue: zod_1.z.number(),
    nonTaxableRevenue: zod_1.z.number(),
    byTaxType: zod_1.z.array(exports.TaxByTypeRowSchema),
    byLocation: zod_1.z.array(exports.TaxByLocationRowSchema),
    byPeriod: zod_1.z.array(exports.TaxByPeriodRowSchema),
});
//# sourceMappingURL=tax-report.schema.js.map